<script setup>
import { useForm } from '@inertiajs/vue3';

const props = defineProps({
    isActive: {
        type: Boolean,
        required: true,
    },
    url: {
        type: String,
        required: true,
    },
    method: {
        type: String,
        default: 'patch',
    },
});

const form = useForm({});

function submit() {
    form.submit(props.method, props.url, {
        preserveScroll: true,
    });
}
</script>

<template>
    <form
        :method="method"
        :action="url"
        aria-checked="false"
        @submit.prevent="submit"
        class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :class="isActive ? 'bg-indigo-600' : 'bg-gray-200'"
    >
        <button type="submit" role="switch" :disabled="form.processing">
            <span class="sr-only">role</span>
            <span
                :class="isActive ? 'translate-x-5' : 'translate-x-0'"
                aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200"
            ></span>
        </button>
    </form>
</template>
